import { caseTypeArray } from 'Components/Client/Cases/CaseFormFields';
import CloseIcon from 'Components/Icons/CloseIcon';
import { Context } from 'Context/Context';
import { getCaseType } from 'Utils';
import React, { useContext, useEffect, useState } from 'react';
import FieldError from '../Element/FieldError';
import { MdOutlineClose } from "react-icons/md";
import { STATE_SELECTION_ENABLED, DEFAULT_STATE } from 'Constants';


function PreferenceFields({states, casePref, setCasePref, setStatePref, statePref, errorMsg, setErrorMsg, isRequired = true}) {
    const {userDetails} = useContext(Context);
    // Texas-only launch: no state picker, the preference is always DEFAULT_STATE
    useEffect(() => {
        if (STATE_SELECTION_ENABLED || !setStatePref) return;
        if (!(Array.isArray(statePref) && statePref.length === 1 && statePref[0] === DEFAULT_STATE)) {
            setStatePref([DEFAULT_STATE]);
            setErrorMsg && setErrorMsg((prev) => ({...prev, "state": ""}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statePref]);
    const handleChange = (e) => {
        setErrorMsg((prev) => { return {...prev, "case" : "" }})
        const value = e?.currentTarget?.value;
        if (!casePref.includes(value)) {
        setCasePref([...casePref, value])
        }
       
    }
    const deleteTag = (index) => {
        setCasePref ((prev) => {
            const arr = [...prev];
            arr.splice(index, 1);
            if(arr.length === 0 && isRequired)
            {
              setErrorMsg((prev) => { return {...prev, "case" : "Please select atleast one case preference"} })
            }
            else if(isRequired)
            {
              setErrorMsg((prev) => { return {...prev, "case" : "" }})
            }
            return arr;
        })

       
    }
    const handleChangeState = (e) => {
        setErrorMsg((prev) => { return {...prev, "state" : "" }})
        const value = e?.currentTarget?.value;
        if (!statePref.includes(value)) {
            setStatePref([...statePref, value])
           
        }
       
       
    }
    const handleBlur = (e) => {
        e.preventDefault();
        if(isRequired)
        {
          if(e.currentTarget.name === "caseType" && casePref.length === 0)
          { 
            setErrorMsg((prev) => { return {...prev, "case" : "Please select atleast one case preference"} })
          }
          else if (e.currentTarget.name === "statePref" && statePref.length === 0)
          {
            setErrorMsg((prev) => { return {...prev, "state" : "Please select atleast one state preference"} })
          }
        }
       
    }
    const deleteTagState = (index) => {
        setStatePref ((prev) => {
            const arr = [...prev];
            arr.splice(index, 1);
            if(isRequired)
            {
            if(arr.length === 0)
              {
                setErrorMsg((prev) => { return {...prev, "state" : "Please select atleast one state preference"} })
              }
              else
              {
                setErrorMsg((prev) => { return {...prev, "state" : "" }})
              }
            }
            return arr;
        })
       
    }
  return (
    <div className='flex w-full items-center  flex-col '>
            <div className='w-full h-full mr-2 '>
           
              <label className="block mt-2 ml-1 text-sm font-bold leading-6 text-gray-900">
              Case Preference
               {
                isRequired ? null : 
                <span className='text-gray-500 font-normal italic text-xs'> (optional)</span>
              }
              </label>
              <div className="relative mt-2 shadow-sm w-full h-full border-red-500 border-1 " 

              >
                 <select id="caseType" 
                  value=""
                  onBlur = {handleBlur}
                  onChange={handleChange}
                  name="caseType" 
                  className={" bg-white text-xs lg:text-sm h-full w-full rounded-md  py-1.5 sm:py-2 pl-2 pr-3 text-gray-500  ring-1 ring-inset ring-gray-300 sm:text-sm  focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 "
                  + (errorMsg?.case !== "" ? " border-red-500 border" : "")
                  }>
                    
                      { isRequired ? 
                      <option value="">
                      -- Choose your case of interest --</option>
                    :
                    <option value="" className='text-xs'>
                      { casePref && casePref.length !== 0 ? "-- Choose more cases of interest --" :  "All cases (default)"}
                     
                      </option>
                    }
                   { caseTypeArray.map((item) => <option value={item.id}>{item.name}</option>)}
                  </select>
              </div>
              {casePref && casePref?.length !== 0 &&
              
              <div className='flex border mb-4 hide-vertical-scrollbar flex-nowrap overflow-x-auto w-full p-2 '>
                {casePref?.map((element, key) => 
                <div className='shrink-0 items-center flex text-xs text-white w-max mr-2 p-2 bg-sky-600 rounded'>
                <div className='mr-2'>{getCaseType(element)}</div>
                <div className='cursor-pointer' onClick={()=>deleteTag(key)}><MdOutlineClose/></div>
                </div>
                )}</div>
                }
            </div>
            {errorMsg?.case && !STATE_SELECTION_ENABLED && <div className='w-full'><FieldError>{errorMsg?.case}</FieldError></div>}
            {STATE_SELECTION_ENABLED && <>
            <div className='w-full h-full mr-2 '>
              {errorMsg?.case && <FieldError>{errorMsg?.case}</FieldError>}
              <label className="block mt-2 ml-1  text-sm font-bold leading-6 text-gray-900">
              State Preference
              {
                isRequired ? null: 
                <span className='text-gray-500 font-normal text-xs italic'> (optional)</span>
              }
              </label>
              <div className="relative mt-2 shadow-sm w-full h-full "
              >
                 <select id="statePref" 
                  value=""
                  onChange={handleChangeState}
                  name="statePref" 
                  onBlur={handleBlur}
                  className={" bg-white rounded-md h-full text-xs lg:text-sm w-full py-1.5 sm:py-2 pl-2 pr-3 text-gray-500  ring-1 ring-inset ring-gray-300 sm:text-sm focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 "
                    +(errorMsg?.state !== "" ? " border-red-500 border" : "")}
                    >
                      
                      { isRequired ? 
                      <option value="">
                      -- Choose your state of interest --</option>
                    :
                    <option value="">
                      { statePref && statePref.length !== 0 ? "-- Choose more states of interest --" :  "All states (default)"}
                     
                      </option>
                    }
                    
                    {states?.map((state) => <option value={state}>{state}</option>)}
                  </select>
              </div>
              
              {statePref && statePref?.length !== 0 &&
              <div className='flex border w-full hide-vertical-scrollbar overflow-x-auto p-2 '>
                {statePref?.map((element, key) => 
                <div className=' items-center flex text-xs text-white w-max mr-2 p-2 bg-sky-600 rounded'>
                <div className='mr-2'>{element}</div>
                <div className='cursor-pointer' onClick={()=>deleteTagState(key)}><MdOutlineClose/></div>
                </div>
                )}</div>
                }
            </div>
            {errorMsg?.state && <FieldError>{errorMsg?.state}</FieldError>}
            </>}
        </div>
  )
}

export default PreferenceFields